import React from "react";
import { css, Global } from "@emotion/react";

/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
const html = css`
  *,
  *:before,
  *:after {
    -webkit-box-sizing: inherit;
    -moz-box-sizing: inherit;
    box-sizing: inherit;
  }

  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

const sections = css`
  body {
    margin: 0;
  }

  main {
    display: block;
  }

  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }
`;

const groupings = css`
  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }

  pre {
    font-family: monospace, monospace;
    font-size: 1em;
  }
`;

const textSemantics = css`
  a {
    background-color: transparent;
  }

  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }

  b,
  strong {
    font-weight: bolder;
  }

  small {
    font-size: 80%;
  }
`;

const img = css`
  img {
    display: block;
    border-style: none;
  }
`;

export const NormalizeCSS = () => (
  <>
    <Global
      styles={css`
        ${html};
        ${sections};
        ${groupings};
        ${textSemantics};
        ${img};
      `}
    />
  </>
);

export default NormalizeCSS;
